import React from 'react';
import { Shield, Heart, Sparkles, Users, ArrowRight } from 'lucide-react';

const ColorTest2 = () => {
  // Extended color palettes
  const palettes = [
    // AMARILLOS / DORADOS
    {
      category: '☀️ AMARILLOS / DORADOS',
      options: [
        {
          name: 'Dorado Antiguo',
          primary: '#8B7355',
          primaryLight: '#9d866a',
          accent: '#d4af37',
          description: 'Dorado envejecido, elegante, atemporal',
          vibe: 'Sabiduría, tradición, calidez noble'
        },
        {
          name: 'Mostaza Terroso',
          primary: '#7d6c3e',
          primaryLight: '#8d7c4e',
          accent: '#c9a227',
          description: 'Mostaza con tierra, orgánico, cálido',
          vibe: 'Natural, honesto, enraizado'
        },
        {
          name: 'Ámbar Profundo',
          primary: '#6b5344',
          primaryLight: '#7b6354',
          accent: '#e6a756',
          description: 'Ámbar con matices tierra',
          vibe: 'Resina, tiempo, preservación'
        },
        {
          name: 'Miel Oscura',
          primary: '#5c4a32',
          primaryLight: '#6c5a42',
          accent: '#daa520',
          description: 'Tono miel profundo y nutritivo',
          vibe: 'Dulzura, nutrición, hogar'
        }
      ]
    },
    // VERDES (más cálidos)
    {
      category: '🌿 VERDES CÁLIDOS',
      options: [
        {
          name: 'Bosque Cálido',
          primary: '#4a5240',
          primaryLight: '#5a6250',
          accent: '#c5a059',
          description: 'Verde bosque con calidez',
          vibe: 'Naturaleza, refugio, crecimiento'
        },
        {
          name: 'Musgo Dorado',
          primary: '#5c5c3d',
          primaryLight: '#6c6c4d',
          accent: '#c9a227',
          description: 'Verde musgo con luz dorada',
          vibe: 'Antiguo, sabio, conectado'
        },
        {
          name: 'Salvia Suave',
          primary: '#6b7c6b',
          primaryLight: '#7b8c7b',
          accent: '#c5a059',
          description: 'Verde grisáceo, herbal, sanador',
          vibe: 'Terapéutico, limpio, sereno'
        },
        {
          name: 'Eucalipto',
          primary: '#5a6e6a',
          primaryLight: '#6a7e7a',
          accent: '#c9a227',
          description: 'Verde azulado, fresco pero cálido',
          vibe: 'Respirar, claridad, sanación'
        }
      ]
    },
    // MORADOS / PÚRPURAS
    {
      category: '💜 MORADOS / PÚRPURAS',
      options: [
        {
          name: 'Berenjena Cálida',
          primary: '#5a4a55',
          primaryLight: '#6a5a65',
          accent: '#c5a059',
          description: 'Púrpura tierra, muy equilibrado',
          vibe: 'Transformación encarnada'
        },
        {
          name: 'Ciruela Madura',
          primary: '#614051',
          primaryLight: '#715061',
          accent: '#c9a227',
          description: 'Púrpura rojizo, profundo',
          vibe: 'Madurez, profundidad, intuición'
        },
        {
          name: 'Lavanda Oscura',
          primary: '#5d5474',
          primaryLight: '#6d6484',
          accent: '#c5a059',
          description: 'Lavanda con profundidad',
          vibe: 'Calma, espiritualidad, sueños'
        },
        {
          name: 'Amatista Terrosa',
          primary: '#6a5a6a',
          primaryLight: '#7a6a7a',
          accent: '#d4af37',
          description: 'Púrpura grisáceo, sofisticado',
          vibe: 'Consciencia, sutileza, protección'
        }
      ]
    },
    // PLATA / METÁLICOS FRÍOS
    {
      category: '🪞 PLATA / METÁLICOS FRÍOS',
      options: [
        {
          name: 'Plata Antigua',
          primary: '#5a5d63',
          primaryLight: '#6a6d73',
          accent: '#c0c0c0',
          description: 'Plata oxidada, elegante',
          vibe: 'Luna, intuición, reflejo'
        },
        {
          name: 'Grafito Cálido',
          primary: '#4d4a47',
          primaryLight: '#5d5a57',
          accent: '#c5a059',
          description: 'Gris oscuro con calidez',
          vibe: 'Estabilidad, profesional, base'
        },
        {
          name: 'Piedra Luna',
          primary: '#6b6e7a',
          primaryLight: '#7b7e8a',
          accent: '#b8c4d0',
          description: 'Gris azulado, etéreo',
          vibe: 'Misterio, feminino, ciclos'
        },
        {
          name: 'Acero Templado',
          primary: '#515a5a',
          primaryLight: '#616a6a',
          accent: '#c9a227',
          description: 'Gris verdoso, fuerte',
          vibe: 'Fortaleza, estructura, límites'
        }
      ]
    },
    // COBRE / METÁLICOS CÁLIDOS
    {
      category: '🔶 COBRE / METÁLICOS CÁLIDOS',
      options: [
        {
          name: 'Cobre Antiguo',
          primary: '#6d5c4a',
          primaryLight: '#7d6c5a',
          accent: '#b87333',
          description: 'Cobre oxidado, noble',
          vibe: 'Alquimia, transformación, valor'
        },
        {
          name: 'Bronce Cálido',
          primary: '#5c4d3d',
          primaryLight: '#6c5d4d',
          accent: '#cd7f32',
          description: 'Bronce con profundidad',
          vibe: 'Antigüedad, durabilidad, honor'
        },
        {
          name: 'Terracota Suave',
          primary: '#6a524a',
          primaryLight: '#7a625a',
          accent: '#c5a059',
          description: 'Terracota apagada, mediterránea',
          vibe: 'Tierra, vasija, contención'
        },
        {
          name: 'Arcilla Dorada',
          primary: '#6b5b4b',
          primaryLight: '#7b6b5b',
          accent: '#daa520',
          description: 'Arcilla con luz solar',
          vibe: 'Crear, moldear, dar forma'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <h1 className="text-4xl font-heading text-center mb-4">Paletas Extendidas</h1>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Variaciones en <strong>amarillos, verdes cálidos, morados, plata y cobre</strong>. 
          Cada color se muestra aplicado a una sección de formación especial.
        </p>

        {palettes.map((category, catIndex) => (
          <div key={catIndex} className="mb-16">
            <h2 className="text-2xl font-heading mb-8 pb-4 border-b-2 border-gray-200">
              {category.category}
            </h2>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {category.options.map((palette, index) => (
                <div key={index} className="space-y-4">
                  {/* Color info */}
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-heading text-lg">{palette.name}</h3>
                      <p className="text-sm text-gray-500">{palette.description}</p>
                      <p className="text-xs mt-1 font-medium" style={{ color: palette.primary }}>
                        ✦ {palette.vibe}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <div 
                        className="w-10 h-10 rounded-lg shadow text-[8px] text-white flex items-center justify-center"
                        style={{ backgroundColor: palette.primary }}
                      >
                        {palette.primary}
                      </div>
                      <div 
                        className="w-10 h-10 rounded-lg shadow text-[8px] text-white flex items-center justify-center"
                        style={{ backgroundColor: palette.accent }}
                      >
                        Acc
                      </div>
                    </div>
                  </div>

                  {/* Mini preview */}
                  <div 
                    className="rounded-2xl overflow-hidden shadow-lg"
                    style={{ background: `linear-gradient(135deg, ${palette.primary} 0%, ${palette.primaryLight} 100%)` }}
                  >
                    <div className="p-6">
                      {/* Badge */}
                      <div 
                        className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 mb-4"
                        style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
                      >
                        <Shield className="w-3 h-3" style={{ color: palette.accent }} />
                        <span className="text-xs text-white/90">Formación Especial</span>
                      </div>

                      <h4 className="text-2xl font-heading text-white mb-1 tracking-tight">
                        LÍMITES
                      </h4>
                      <p className="text-sm text-white/60 mb-4">
                        La protección original de la consciencia
                      </p>

                      {/* Mini pillars */}
                      <div className="flex gap-2 mb-4">
                        {[Heart, Sparkles, Shield].map((Icon, i) => (
                          <div 
                            key={i}
                            className="w-8 h-8 rounded-lg flex items-center justify-center"
                            style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
                          >
                            <Icon className="w-4 h-4" style={{ color: palette.accent }} strokeWidth={1.5} />
                          </div>
                        ))}
                      </div>

                      {/* Quote */}
                      <p className="text-sm font-heading text-white/80 italic mb-4">
                        "Cuando el cuerpo está protegido, el alma puede permanecer abierta."
                      </p>

                      {/* Buttons */}
                      <div className="flex gap-2">
                        <button 
                          className="px-4 py-2 rounded-full text-xs font-medium"
                          style={{ backgroundColor: 'white', color: palette.primary }}
                        >
                          Solicitar acceso
                        </button>
                        <button 
                          className="px-4 py-2 rounded-full text-xs font-medium text-white"
                          style={{ backgroundColor: palette.accent }}
                        >
                          Ver más
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Light section mini */}
                  <div className="flex gap-2">
                    <span 
                      className="px-3 py-1 rounded-full text-xs text-white"
                      style={{ backgroundColor: palette.primary }}
                    >
                      Primario
                    </span>
                    <span 
                      className="px-3 py-1 rounded-full text-xs border"
                      style={{ borderColor: palette.primary, color: palette.primary }}
                    >
                      Outline
                    </span>
                    <span 
                      className="px-3 py-1 rounded-full text-xs text-white"
                      style={{ backgroundColor: palette.accent }}
                    >
                      Acento
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* My top picks */}
        <div className="mt-16 p-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl">
          <h2 className="text-2xl font-heading mb-6 text-center">🏆 Mis Favoritas para tu Escuela</h2>
          <div className="grid md:grid-cols-4 gap-4">
            {[
              { name: 'Musgo Dorado', color: '#5c5c3d', reason: 'Conecta naturaleza + sabiduría' },
              { name: 'Berenjena Cálida', color: '#5a4a55', reason: 'Transformación encarnada' },
              { name: 'Cobre Antiguo', color: '#6d5c4a', reason: 'Alquimia + valor' },
              { name: 'Terracota Suave', color: '#6a524a', reason: 'Contención + calidez' }
            ].map((pick, i) => (
              <div key={i} className="bg-white p-4 rounded-xl shadow-sm text-center">
                <div 
                  className="w-16 h-16 rounded-full mx-auto mb-3 shadow-md"
                  style={{ backgroundColor: pick.color }}
                />
                <h3 className="font-heading text-sm mb-1">{pick.name}</h3>
                <p className="text-xs text-gray-500">{pick.reason}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Color codes reference */}
        <div className="mt-12 p-6 bg-gray-900 rounded-2xl text-white">
          <h3 className="font-heading mb-4">📋 Códigos Rápidos</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 text-xs font-mono">
            <div><span className="text-yellow-400">Dorado Antiguo:</span> #8B7355</div>
            <div><span className="text-yellow-400">Mostaza:</span> #7d6c3e</div>
            <div><span className="text-green-400">Musgo Dorado:</span> #5c5c3d</div>
            <div><span className="text-green-400">Salvia:</span> #6b7c6b</div>
            <div><span className="text-purple-400">Berenjena:</span> #5a4a55</div>
            <div><span className="text-purple-400">Amatista:</span> #6a5a6a</div>
            <div><span className="text-gray-400">Plata:</span> #5a5d63</div>
            <div><span className="text-gray-400">Grafito:</span> #4d4a47</div>
            <div><span className="text-orange-400">Cobre:</span> #6d5c4a</div>
            <div><span className="text-orange-400">Bronce:</span> #5c4d3d</div>
            <div><span className="text-orange-400">Terracota:</span> #6a524a</div>
            <div><span className="text-orange-400">Arcilla:</span> #6b5b4b</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorTest2;
